export const HOME = { emergentLink: 'home-emergent-link' };

export const NAV = {
  brand: 'nav-brand',
  link: (k) => `nav-link-${k}`,
  ctaEarly: 'nav-cta-early-access',
  menuToggle: 'nav-mobile-toggle',
  mobilePanel: 'nav-mobile-panel',
};

export const HERO = {
  headline: 'hero-headline',
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  statusLabel: 'hero-status-label',
};

export const FORMS = {
  earlyAccess: {
    form: 'early-access-form',
    firstName: 'ea-first-name',
    lastName: 'ea-last-name',
    email: 'ea-email',
    country: 'ea-country',
    interest: 'ea-primary-interest',
    message: 'ea-message',
    consent: 'ea-consent',
    submit: 'ea-submit',
    success: 'ea-success',
    error: 'ea-error',
  },
  contact: {
    form: 'contact-form',
    name: 'contact-name',
    email: 'contact-email',
    organisation: 'contact-organisation',
    topic: 'contact-topic',
    message: 'contact-message',
    consent: 'contact-consent',
    submit: 'contact-submit',
    success: 'contact-success',
    error: 'contact-error',
  },
};

export const ADMIN = {
  email: 'admin-email',
  password: 'admin-password',
  submit: 'admin-submit',
  logout: 'admin-logout',
  tabSubmissions: 'admin-tab-submissions',
  tabContact: 'admin-tab-contact',
  tabFaqs: 'admin-tab-faqs',
  tabResearch: 'admin-tab-research',
};
